export default __webpack_public_path__ + "img/payout.6de674a0fb43603c7143b0cf5d980f73.png";